import { Group } from "@/models/feature/feature";
import { create } from "zustand";

type FeatureStore = {
  groups: Group[];
  isGroupsOpen: boolean;
  setGroups: (groups: Group[]) => void;
  toggleIsGroupsOpen: () => void;
  reset: () => void;
};

const initialState = {
  groups: [],
  isGroupsOpen: false,
};

const useFeatureStore = create<FeatureStore>((set) => ({
  ...initialState,
  setGroups: (groups: Group[]) => set({ groups }),
  toggleIsGroupsOpen: () =>
    set((state) => ({ isGroupsOpen: !state.isGroupsOpen })), // Toggle the isGroupsOpen state
  reset: () => set(initialState),
}));

export default useFeatureStore;
